"use client";

import { useQuery } from "@tanstack/react-query";
import { Database } from "@punchup/data/supabase.types";
import { createClientComponentClient } from "@punchup/data/supabase/client";
import {
  Livestream,
  getLivestreamById,
} from "@punchup/data/legacy/livestreaming";

interface UseLivestreamOptions {
  livestreamId: string | null | undefined;
  enabled?: boolean;
}

export function useLivestream({
  livestreamId,
  enabled = true,
}: UseLivestreamOptions) {
  const {
    data: livestream,
    isLoading,
    error,
    refetch,
  } = useQuery<Livestream | null>({
    queryKey: ["livestream", livestreamId],
    queryFn: async () => {
      if (!livestreamId) return null;
      const supabase = createClientComponentClient<Database>();
      return getLivestreamById(supabase, livestreamId);
    },
    enabled: enabled && !!livestreamId,
    staleTime: 30 * 1000, // 30 seconds
    gcTime: 5 * 60 * 1000, // 5 minutes
  });

  return {
    livestream,
    isLoading,
    error,
    refetch,
  };
}
